import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PipelineService } from 'src/app/core/services/pipeline.service';

@Component({
  selector: 'app-modal-pipeline-save',
  templateUrl: './modal-pipeline-save.component.html'
})
export class ModalPipelineSaveComponent implements OnInit {
  title: string;
  closeBtnName: string;
  completePercent: number;
  state: string;
  widthStyle = 'width: 0%';
  states: string[] = [
    'pipeline-process-initialize',
    'pipeline-process-saving',
    'pipeline-process-complete'
  ];
  statePercent: number = (100 / this.states.length);

  constructor(
    public bsModalRef: BsModalRef,
    protected pipelineService: PipelineService
  ) { }

  ngOnInit(): void {
    this.completePercent = this.statePercent;
    this.updateWidthStyle(this.completePercent.toString());

    this.pipelineService.pipelineSaveState$.subscribe(response => {
      if (this.state !== response.state) {
        this.state = response.state;
        this.completePercent += this.statePercent;
        this.updateWidthStyle(this.completePercent.toString());
      }
    });
  }

  private updateWidthStyle(percent: string): void {
    this.widthStyle = 'width: ' + percent + '%';
  }

}
